<template>
	<div>
		<div class="v-input theme--light v-text-field v-text-field--is-booted">
			<div class="v-input__control">
				<div class="v-input__slot">
					<div class="v-text-field__slot">
						<input
							v-model="txtAddress"
							style="background: url(/images/map-marker-icon.png) no-repeat right;"
							@focus="pageReadyFlag = true"
							@input="onAddressChange"
							:placeholder="$t('labels.StartTypingYourAddress')"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="resultsDiv" v-if="results.length > 0">
			<div>
				<v-list-item v-for="r in results" v-bind:key="r.Id" @click="onAddressClick(r)">
					<v-list-item-content>
						<v-list-item-title>
							<i v-if="r.Next == 'Find'" class="far fa-arrow-alt-circle-right mr-2" />
							<i v-else class="fas fa-map-marker-alt mr-2" />
							<span class="addressText" v-html="r.Html" />
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</div>
			<div class="text-center mb-1"><i @click="reset" title="Close" class="far xLink text-danger fa-2x fa-times-circle"></i></div>
		</div>

		<div class="loading" v-if="loadFlag">Loading&#8230;</div>
	</div>
</template>

<script>
import dataSvc from "@/services/dataService";
export default {
	props: ["line1", "easyMode"],
	data() {
		return {
			loadFlag: false,
			key: process.env.VUE_APP_CANADAPOST_KEY,
			findAddress: null,
			pageReadyFlag: false,
			searchIdx: 1,
			txtAddress: null,
			results: [],
			mapAddress: null,
			siteID: this.$route.params.siteid,
		};
	},
	methods: {
		onAddressChange() {
			if (!this.txtAddress) {
				this.reset();
				return;
			}
			let url = "https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3ex.ws";
			url += "?key=" + encodeURIComponent(this.key);
			url += "&SearchTerm=" + encodeURIComponent(this.txtAddress);
			url += "&LanguagePreference=en&SearchFor=Everything&Orderby=UserLocation&Country=CAN";
			$.get(url).then((res) => {
				this.results = res.Items;
				this.setupHighLight();
			});
		},
		setupHighLight() {
			for (let i = 0; i < this.results.length; i++) {
				let h = "";
				try {
					let hl = this.results[i].Highlight;
					if (hl) {
						let t = this.results[i].Text;
						let arrHL = hl.split(",");
						let currentIdx = 0;
						for (let j = 0; j < arrHL.length; j++) {
							let from = Number(arrHL[j].split("-")[0]);
							let to = Number(arrHL[j].split("-")[1]);

							if (from > currentIdx) {
								h += t.substring(currentIdx, from);
							}
							currentIdx = to;
							let txt = t.substring(from, to);
							h += '<span class="AddressHighLight">' + txt + "</span>";
						}
						if (t.length > currentIdx) h += t.substr(currentIdx);
					} else {
						h += this.results[i].Text + " ";
					}
					//h += " - " + this.results[i].Text;
					h += '<span class="text-muted ml-3">' + this.results[i].Description + "</span>";
					this.results[i].Html = h;
				} catch (err) {
					this.results[i].Html = err;
				}
			}
		},
		reset() {
			this.txtAddress = "";
			this.results = [];
			this.mapAddress = null;
		},
		onAddressClick(addr) {
			if (addr.Next == "Find") this.nextFind(addr);
			if (addr.Next == "Retrieve") this.retrieveSaved(addr);
		},
		nextFind(addr) {
			let url = "https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3ex.ws";
			url += "?key=" + encodeURIComponent(this.key);
			url += "&SearchTerm=" + encodeURIComponent(addr.Text);
			url += "&LastId=" + encodeURIComponent(addr.Id);
			url += "&LanguagePreference=en&SearchFor=Everything&Orderby=UserLocation&Country=CAN&MaxSuggestions=20&MaxResults=20";
			$.get(url).then((res) => {
				this.results = res.Items;
				this.setupHighLight();
			});
		},

		async retrieveSaved(addr) {
			let postData = {
				Id: addr.Id,
				SiteID: this.siteID
			};
			this.loadFlag = true;
			dataSvc
				.getHttp()
				.post("api/LoadCanadaPostResults", postData)
				.then((res) => {
					this.loadFlag = false;
					if (res.data.Addr) {
						this.$emit("onSelect", res.data.Addr);
						this.reset();
					} else {
						this.retrieve(addr);
					}
				});
		},

		retrieve(addr) {
			let url = "https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/RetrieveById/v1.00/json3ex.ws";
			url += "?key=" + encodeURIComponent(this.key);
			url += "&Id=" + encodeURIComponent(addr.Id);
			this.loadFlag = true;
			$.get(url).then((res) => {
				this.loadFlag = false;
				let addrDetails = {
					Unit: null,
					StreetNumber: null,
					StreetName: null,
					StreetTypeDD: null,
					StreetDirectionDD: null,
					City: null,
					ProvinceDD: null,
					PostalFsa: null,
					PostalLdu: null,
					CountryTypeDD: 1,
				};
				addrDetails.City = this.getValue(res, "Common", "City");
				addrDetails.PostalFsa = this.getValue(res, "Country", "PostalCodePrefix");
				addrDetails.PostalLdu = this.getValue(res, "Country", "PostalCodeSuffix");
				addrDetails.StreetNumber = this.getValue(res, "Country", "StreetNumber");
				addrDetails.StreetName = this.getValue(res, "Country", "StreetName");
				addrDetails.Unit = this.getValue(res, "Common", "SubBuilding");

				let strProvince = this.getValue(res, "Common", "ProvinceCode");
				let strStreetType = this.getValue(res, "Country", "StreetType");
				let strStreetDirection = this.getValue(res, "Country", "StreetPostDirection");

				let postData = {
					Province: strProvince,
					StreetType: strStreetType,
					StreetDirection: strStreetDirection,
					SiteID: this.siteID,
				};
				this.loadFlag = true;
				dataSvc
					.getHttp()
					.post("api/GetAddressComponents", postData)
					.then((res) => {
						this.loadFlag = false;
						const rv = res.data;
						addrDetails.ProvinceDD = rv.ProvinceDD;
						addrDetails.StreetTypeDD = rv.StreetTypeDD;
						addrDetails.StreetDirectionDD = rv.StreetDirectionDD;

						let canadaPostData = {
							Id: addr.Id,
							Addr: addrDetails,
							SiteID: this.siteID
						};

						dataSvc.getHttp().post("api/SaveCanadaPostResults", canadaPostData).then((res) => {
							this.$emit("onSelect", addrDetails);
							this.reset();
						});
					});
			});
		},
		getValue(list, group, key) {
			let v = list.Items.find((o) => o.FieldName == key && o.Language == "ENG" && o.FieldGroup == group);
			if (v) return v.FormattedValue;

			v = list.Items.find((o) => o.FieldName == key && o.Language == "FRE" && o.FieldGroup == group);
			if (v) return v.FormattedValue;

			return null;
		},
		onAddressHover(addr) {
			this.mapAddress = addr;
		},
	},
	watch: {},
};
</script>
<style scoped>
.resultsDiv {
	background-color: #e6eafd;
}
</style>
